import { getCookie, setCookie } from '@frontend/cookie';

export type Channel = {
  label: string;
  slug: string;
  value: string;
  description: string;
};

const cookieName = 'siteName';

/**
 *
 * Gets the user channel and sets it in their cookie if it's not there
 * We don't want the cookie if the channel is 'stable' because that's the default anyway
 * If its a weave user, we want to assign them to the 'edge' channel
 */
export const getUserChannel = (isWeaveUser: boolean, channels: Channel[] | undefined): Channel | undefined => {
  const cookieChannel = getCookie(cookieName);
  const channel = cookieChannel ? channels?.find((c) => c.value === cookieChannel) : undefined;
  if (channel) {
    return channel;
  }

  if (isWeaveUser && !channel) {
    const edgeChannel = channels?.find((c) => c.slug === 'edge') ?? channels?.[0];
    if (edgeChannel) {
      setCookie({ name: cookieName, value: edgeChannel.value });
      return edgeChannel;
    }
  }

  return channels?.find((channel) => channel.slug === 'stable') ?? channels?.[0];
};

export const setUserChannel = (channel: Channel) => {
  setCookie({ name: cookieName, value: channel.value });
};
